import React from 'react';
import { LogOut, ChevronDown, Menu } from 'lucide-react';
import { useStore } from '../store';
import { useShallow } from 'zustand/react/shallow';
import {
  Header as DesignSystemHeader,
  Popover,
  PopoverTrigger,
  PopoverContent,
  Button,
  Separator,
} from '@roger/ui-components';
import AgencySwitcher from './AgencySwitcher';

const Header: React.FC = () => {
  const { user, logout, toggleSidebar, isSidebarCollapsed } = useStore(
    useShallow(state => ({
      user: state.user,
      logout: state.logout,
      toggleSidebar: state.toggleSidebar,
      isSidebarCollapsed: state.isSidebarCollapsed,
    }))
  );

  // Helper to get initials
  const getInitials = (name?: string) => {
    if (!name) return 'U';
    return name
      .split(' ')
      .map(n => n[0])
      .join('')
      .toUpperCase();
  };

  const actions = (
    <div className='flex items-center gap-4'>
      <AgencySwitcher />

      {/* User Menu */}
      <Popover>
        <PopoverTrigger asChild>
          <button className='flex items-center gap-1 px-1 py-0.5 rounded-lg hover:bg-accent focus:outline-none'>
            <div className='h-8 w-8 rounded-full bg-primary text-white flex items-center justify-center font-semibold'>
              {getInitials(user?.name)}
            </div>
            <div className='hidden sm:block text-left'>
              <div className='text-sm font-medium leading-tight'>
                {user?.name || 'User'}
              </div>
            </div>
            <ChevronDown className='h-4 w-4 text-muted-foreground ml-1' />
          </button>
        </PopoverTrigger>
        <PopoverContent align='end' className='w-64 p-0'>
          <div className='p-2 pb-1 flex items-center gap-2'>
            <div>
              <div className='font-semibold text-base'>
                {user?.name || 'User'}
              </div>
              <div className='text-xs text-muted-foreground'>
                {user?.email || 'user@roger.com'}
              </div>
            </div>
          </div>
          <Separator className='my-2' />
          <div className='px-2 pb-2'>
            <Button
              variant='ghost'
              className='w-full justify-start text-destructive'
              onClick={logout}
            >
              <LogOut className='h-4 w-4' /> Sign Out
            </Button>
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );

  return (
    <DesignSystemHeader
      title={
        <button
          onClick={toggleSidebar}
          className='z-50 h-6 w-6 rounded-full flex items-center justify-center transition-colors duration-200 shadow-2xl border bg-white'
        >
          <Menu
            className={`h-3.5 w-3.5 text-primary transition-transform duration-300 ${isSidebarCollapsed ? 'rotate-180' : ''}`}
          />
        </button>
      }
      actions={actions}
    />
  );
};

export default Header;
